import React from 'react';
import type { BoardLinkListBaseProps } from './boardLinkTypes';
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';
import { GridList } from 'react-aria-components';
import BoardLinkListItem from './BoardLinkListItem';
import { getElementId } from '../../../../../common/elements/utils/elementPropertyUtils';

type BoardLinkListProps = BoardLinkListBaseProps & {
    boards: ImMNElement[];
    size?: 'sm' | 'lg';
};

const BoardLinkList: React.FC<BoardLinkListProps> = ({ boards, gridSize, onSelect, isSheet, size }) => {
    return (
        <div className="BoardLinkList">
            <GridList aria-label="Board links" className="w-full min-w-0 outline-hidden">
                {boards.map((board) => (
                    <BoardLinkListItem
                        key={getElementId(board)}
                        board={board}
                        gridSize={gridSize}
                        onSelect={onSelect}
                        isSheet={isSheet}
                        size={size}
                    />
                ))}
            </GridList>
        </div>
    );
};

export default BoardLinkList;
